import { render, staticRenderFns } from "./GlSelectionTable.vue?vue&type=template&id=64bc0c9a&scoped=true"
import script from "./GlSelectionTable.vue?vue&type=script&lang=js"
export * from "./GlSelectionTable.vue?vue&type=script&lang=js"
import style0 from "./GlSelectionTable.vue?vue&type=style&index=0&id=64bc0c9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64bc0c9a",
  null
  
)

export default component.exports